import m from "moment";
import { OutletState as t } from "@ancon/wildcat-types";
const r = 60;
var T = /* @__PURE__ */ ((e) => (e[e.Today = 0] = "Today", e[e.Tomorrow = 1] = "Tomorrow", e))(T || {});
function p(e, o, l = !1) {
  let s = null;
  if (e.openNow && e.closingTime !== null)
    (e.closingTime.diff(o, "minutes") < r || l) && (s = {
      time: e.closingTime.format("LT"),
      state: t.Closed
    });
  else if (!e.openNow && e.openingTime)
    if (e.openingTime.isSame(o, "d"))
      s = {
        time: m(e.openingTime).calendar(),
        state: t.Opened
      };
    else {
      const d = m().add(1, "day"), i = m(e.openingTime);
      i.isSame(d, "d") ? s = {
        time: i.format("LT"),
        state: t.Opened,
        day: 1
        /* Tomorrow */
      } : i.isAfter(o.clone().add(1, "week")) ? s = {
        time: i.format("D MMMM LT"),
        state: t.Opened
      } : i && (s = {
        time: i.format("ddd LT"),
        state: t.Opened
      });
    }
  return s;
}
export {
  T as OutletAvailabilityDay,
  p as default
};
